import { z } from "zod";

export const userConnectedAccountStatuses = [
  "active",
  "disconnected",
  "error",
  "reauth_required",
] as const;

export const UserConnectedAccountSchema = z.object({
  id: z.string().uuid().describe("ID"),
  provider: z.string().describe("Provider"),
  external_account_id: z.string().nullable().describe("Connected Account"),
  scopes: z.array(z.string()).describe("Scopes"),
  status: z.enum(userConnectedAccountStatuses).describe("Status"),
  connected_at: z.string().datetime().describe("Connected"),
});
export type UserConnectedAccount = z.infer<typeof UserConnectedAccountSchema>;

export const UserConnectedAccountsResponseSchema = z.object({
  accounts: z.array(UserConnectedAccountSchema).describe("Accounts"),
});
export type UserConnectedAccountsResponse = z.infer<
  typeof UserConnectedAccountsResponseSchema
>;

export const UserConnectedAccountConnectResponseSchema = z.object({
  auth_url: z.string().url().describe("Auth URL"),
});
export type UserConnectedAccountConnectResponse = z.infer<
  typeof UserConnectedAccountConnectResponseSchema
>;
